module.exports = __webpack_public_path__ + "img/training-fitness.b599bf1d.svg";